  <!-- *ngIf="uploadCompleted==false && file_index!=''" -->
  <div class="container-shadow p-3 mb-3 bg-white"
    *ngIf="(dss?.feed_post_in_process?.is_show==true && dss.feed_post_in_process?.file_url!='' && dss.feed_post_in_process?.status=='in_process')">
    <div class="row">
      <div class="col-2 img-max-width">
        <div class="post-proc">
          <img class="post-proc-img rounded" [src]="dss.feed_post_in_process?.file_url"
            onerror="this.src='assets/themes/icons/posting-svg.svg'" />
        </div>
      </div>
      <div class="col-12 pl-0 post-prcss-img">
        <p class="secondary-paragraph mt-2 mb-2">
          <span class="color-grey-700">{{mls.languageText.post_process.key1}}<span
              *ngIf="mls?.is_lskey_display==1">(post_process.key1)</span></span>
        </p>
        <div class="post-processing bg-grey-300 position-relative rounded">
          <div class="success-process position-absolute h-100 bg-black progress-bar-start"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-shadow bg-white p-3 mb-3 bg-white"
    *ngIf="(dss.feed_post_in_process?.is_show==true && dss.feed_post_in_process?.file_url=='' && dss.feed_post_in_process?.status=='in_process')">
    <div class="row">

      <div class="col-12">
        <p class="secondary-paragraph mt-2 mb-2"><span
            class="color-grey-700">{{mls.languageText.post_process.key1}}<span
              *ngIf="mls?.is_lskey_display==1">(post_process.key1)</span></span></p>
        <div class="post-processing bg-grey-300 position-relative rounded">
          <div class="success-process position-absolute h-100 bg-black progress-bar-end"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- successfully posted -->
  <div class="px-3 py-4 container-shadow blue-border mb-3 text-center bg-blue-200"
    *ngIf="(dss.feed_post_in_process?.is_show==true && dss.feed_post_in_process?.status=='completed')">
    <p class="heading-4">
      <img width="24" src="assets/themes/icons/green-check.svg" alt="posted-icon">
      {{mls.languageText.post_process.key2}}<span *ngIf="mls?.is_lskey_display==1">(post_process.key2)</span>
    </p>
  </div>

  <div *ngIf="dss.feed_post_in_process?.status=='failed'" class="container-shadow p-3 mb-3 secondary-paragraph bg-white">
    <div class="clearfix pb-2">
      <div class="float-left user-40 mr-2"><img class="post-proc-img user-40 post-pic-img rounded"
          src="assets/themes/icons/posting-svg.svg"
          onerror="this.src='assets/themes/icons/banner-placeholder.svg'" /></div>
      <div class="float-left w-100 content-max-width">
        <p class="paragraph-bold">{{mls.languageText.post_process.key3}}<span
            *ngIf="mls?.is_lskey_display==1">(post_process.key3)</span></p>
        <p class="secondary-paragraph"><span class="color-grey-700">{{mls.languageText.post_process.key4}}<span
              *ngIf="mls?.is_lskey_display==1">(post_process.key4)</span></span></p>
      </div>
      <div (click)="retryFeedPost()" class="float-right">
        <button class="btn-design filled small"><img width="16px" src="assets/themes/icons/white-refresh-arrow.svg"
            class="mr-1" />{{mls.languageText.post_process.key5}}<span
            *ngIf="mls?.is_lskey_display==1">(post_process.key5)</span></button>
      </div>
    </div>
    <div class="border-top pt-3 text-center mt-2">
      <span (click)="cancelPost()" class="cursor-pointer button">
        <img src="assets/themes/icons/cancel.svg" alt="cross">
        Dismiss</span>
    </div>
  </div>